'use strict';

angular.module('admin')

.controller('EditCtrl', function ($scope, model, modelNameField)
{
    $scope.model = model;
    $scope.modelNameField = modelNameField;

    $scope.saveModel = function ()
    {
        $scope.model.DSCreate(model, {upsert: true}).then($scope.$close);
    };
});
